import { createMuiTheme } from '@material-ui/core/styles';

const GlobalThemeV4 = createMuiTheme({
    palette: {
        primary: {
            main: '#1976d2',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#d5001c',
            contrastText: '#ffffff',
        },
    },
});

export default GlobalThemeV4;



// WEBPACK FOOTER //
// ./src/GlobalThemeV4.tsx